module.exports = __webpack_public_path__ + "img/close.3c8589e4.svg";